import { create } from 'zustand';

export const useSegments = create((set) => ({
  addItem: (imageUrl, shapes) => set({ [imageUrl]: shapes }),
  removeItem: (imageUrl) => set({ [imageUrl]: undefined }),
  initItems: (items) => set(items),
  clear: () => set({}),
}));
